import $ from 'jquery';

const CategoryFilter = (el) => {
    const $el = $(el);
    $el.change(function(e) {
        this.form.submit();
    });
};

export default CategoryFilter;
